export const ThrowStatement = {
  print: () => 'throw;'
};
